import { Component } from '../bootstrap/component'
import { getElementID } from './DOM';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export class SliderHomepage extends Component {
  slider: HTMLElement;
  navContainer: HTMLElement;
  controlsContainer: HTMLElement;
  activeIndex: number;

  onInit() {
    this.slider = getElementID('slider-homepage-hex');

    if (!this.slider) {
      return false;
    }

    this.navContainer = getElementID('slider-homepage-hex-nav');
    this.controlsContainer = getElementID('slider-homepage-hex-controls');

    new Swiper(this.slider, {
      loop: true,
      autoplay: false,
      centeredSlides: true,
      navigation: {
        prevEl: '.slider-controls__item.isPrev',
        nextEl: '.slider-controls__item.isNext',
      },
      slidesPerView: 1,
      roundLengths: true,
      spaceBetween: 300,
      breakpoints: {
        600: {
          slidesPerView: 3,
          loopedSlides: 4,
        },
      },
      pagination: {
        el: this.navContainer,
        clickable: true,
        bulletActiveClass: 'isActive',
        bulletClass: 'slider-navigation__item',
        modifierClass: 'slider-navigation__item--',
        renderBullet: (index, className) => {
          return `<button class="${className}"></button>`;
        }
      },
      on: {
        resize: (swiper) => {
          let goTo: number = 1;

          if (window.matchMedia(`(min-width: 600px)`).matches) {
            goTo = 4;
          }

          swiper.slideTo(goTo);
        }
      }
    })

    // tns({
    //   loop: true,
    //   container: this.slider,
    //   mouseDrag: false,
    //   autoplay: false,
    //   controls: true,
    //   nav: true,
    //   // @ts-ignore
    //   center: true,
    //   navContainer: this.navContainer,
    //   controlsContainer: this.controlsContainer,
    //   items: 1,
    //   fixedWidth: 273,
    //   gutter: 110,
    //   onInit: () => {
    //     this.setMarkedSlide();
    //   }
    // }).events.on('transitionEnd', () => {
    //   this.setMarkedSlide();
    // });
  }

  public setMarkedSlide() {
    const visibleElements = this.slider.getElementsByClassName('tns-slide-active');

    if (visibleElements.length > 1) {
      visibleElements[1].classList.add('slide-is-centered');
    }
  }
}